import axios from 'axios';
import config from 'config';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true
});
axiosInstance.prototype.lastCalledOn = null;

axiosInstance.interceptors.response.use(
  (response) => {
    // set time when last request was made
    axiosInstance.lastCalledOn = Date.now();

    // update session timeout variable
    try {
      if (typeof window !== 'undefined' && sessionStorage) {
        sessionStorage.setItem('vuoSessionUpdated', Date.now().toString());
      }
    } catch (err) {
      console.error(err);
    }

    return response;
  },
  (error) => {
    const { response } = error;
    if (response?.data?.isSessionDestroyed) {
      const sessionDestroyed = sessionStorage.getItem('vuoSessionIsDestroyed');
      if (sessionDestroyed !== 'true') return (window.location.href = '/401');
      else sessionStorage.setItem('vuoSessionIsDestroyed', 'true');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
